export const GET_SUCCESS_CONFIGURATION_TYPE_REQUEST = 'GET_SUCCESS_CONFIGURATION_TYPE_REQUEST';
export const GET_SUCCESS_CONFIGURATION_TYPE_SUCCESS = 'GET_SUCCESS_CONFIGURATION_TYPE_SUCCESS';
export const GET_SUCCESS_CONFIGURATION_TYPE_FAILED = 'GET_SUCCESS_CONFIGURATION_TYPE_FAILED';

export const UPDATE_SUCCESS_CONFIGURATION_TYPE_REQUEST = 'UPDATE_SUCCESS_CONFIGURATION_TYPE_REQUEST';
export const UPDATE_SUCCESS_CONFIGURATION_TYPE_SUCCESS = 'UPDATE_SUCCESS_CONFIGURATION_TYPE_SUCCESS';
export const UPDATE_SUCCESS_CONFIGURATION_TYPE_FAILED = 'UPDATE_SUCCESS_CONFIGURATION_TYPE_FAILED';

export const CANCEL_SUCCESSED = 'CANCEL_SUCCESSED';
